import React, { useState } from "react";

export function Section(
  props: React.PropsWithChildren<
    {
      title?: { number?: number; name: string };
      grey?: boolean;
      noBorder?: boolean;
      m?: number;
      disable?: boolean;
    }
  >,
) {
  const classNames: string[] = [];

  if (props.grey) classNames.push("--grey");
  if (props.noBorder) classNames.push("--no-border");
  if (props.disable) classNames.push("--disable");

  const title = props.title
    ? (
      <div className="Section__Title">
        {props.title.number ? <span className="number">{props.title.number}.</span> : null}
        <span>{props.title.name}</span>
      </div>
    )
    : null;

  const inner = (
    <div className={`Section__Inner ${props.m ? `--m-${props.m}` : ""}`}>{props.children}</div>
  );

  return (
    <section className={`Section ${classNames.join(" ")}`}>
      {title}
      {inner}
    </section>
  );
}
